import React from 'react'
import { SelectInlineInput } from '@ztechapps/webui.input'
import { SerialNumberTypeSelect } from './SerialNumberTypeSelect'
import { serialNumberTypeOptions } from './serialNumberTypeOptions'

export const SerialNumberTypeSelectInlineInput = ({ ...rest }: any) => {
  return (
    <SelectInlineInput {...rest} selectComponent={SerialNumberTypeSelect} selectOptions={serialNumberTypeOptions} />
  )
}
